module.exports = __webpack_public_path__ + "img/facebook-monochrome.dee82012.svg";